import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ToastContainer, toast } from "react-toastify";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import "react-toastify/dist/ReactToastify.css";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

function FetchCampus() {
  const [showFetchModal, setShowFetchModal] = useState(false);
  const [fetchName, setFetchName] = useState("");
  const [fetchDescription, setFetchDescription] = useState("");
  const [apiLink, setApiLink] = useState("");
  const [mainVariable, setMainVariable] = useState("");
  const [auth, setAuth] = useState("no-auth");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [bearerToken, setBearerToken] = useState("");
  const [fetchedData, setFetchedData] = useState([]);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleShowFetchModal = () => {
    setShowFetchModal(true);
  };

  const handleCancelFetchModal = () => {
    setShowFetchModal(false);
  };

  const handleCancelConfirmationModal = () => {
    setShowConfirmationModal(false);
    setFetchedData([]);
  };

  const addCampuses = () => {
    const mappedCampuses = fetchedData.map((campus) => ({
      name: getNestedProperty(campus, fetchName),
      description: getNestedProperty(campus, fetchDescription),
    }));

    console.log(mappedCampuses);
    let data = { campuses: mappedCampuses };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(data),
    };
    fetch(`${BASE_URL}/api/campus/add_campuses`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        toast.success("Campuses Added Successfully");
      })
      .catch((error) => console.log(error));
  };

  const handleOkFetchModal = () => {
    let headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    };

    if (auth === "basic-auth") {
      headers["Authorization"] = `Basic ${btoa(`${userName}:${password}`)}`;
    } else if (auth === "token-auth") {
      headers["Authorization"] = `Bearer ${bearerToken}`;
    }

    const requestOptions = {
      method: "GET",
      headers: headers,
    };

    fetch(apiLink, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Error: ${response.status} ${response.statusText}`);
        }
        return response.json();
      })
      .then((data) => {
        if (mainVariable) {
          setFetchedData(getNestedProperty(data, mainVariable));
        } else {
          setFetchedData(data);
        }
        setShowConfirmationModal(true);
      })
      .catch((error) => {
        console.error(error);
        toast.error(`Failed to fetch data: ${error.message}`);
      });

    setShowFetchModal(false);
  };

  const handleConfirmFetch = () => {
    addCampuses();
    setShowConfirmationModal(false);
    setFetchedData([]);
  };

  const getNestedProperty = (obj, path) => {
    const parts = path.split(".");
    let value = obj;
    for (let part of parts) {
      if (part.includes("[")) {
        const index = part.match(/\[(.*?)\]/)[1];
        value = value[part.split("[")[0]][index];
      } else {
        value = value[part];
      }
    }
    return value;
  };

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<CloudUploadIcon />}
        onClick={handleShowFetchModal}
        style={{
          color: "#414149",
          borderColor: "#414149",
          fontWeight: "bold",
        }}
      >
        Fetch Campuses
      </Button>
      <Dialog
        fullScreen={fullScreen}
        open={showFetchModal}
        onClose={handleCancelFetchModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{"Fetch Campuses"}</DialogTitle>
        <DialogContent>
          <div className="row">
            <div className="col-md-12">
              <h6 className="text-danger">Note: API should have a GET route</h6>
            </div>
            <div className="col-md-4 mt-2">
              <h5>1. Name</h5>
            </div>
            <div className="col-md-8">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Your Field Name (e.g., details.name)"
                value={fetchName}
                onChange={(e) => setFetchName(e.target.value)}
              />
            </div>
            <div className="col-md-4 mt-3">
              <h5>2. Description</h5>
            </div>
            <div className="col-md-8 mt-2">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Your Field Name (e.g., reviews.rating)"
                value={fetchDescription}
                onChange={(e) => setFetchDescription(e.target.value)}
              />
            </div>
            <div className="col-md-4 mt-3">
              <h5>Auth</h5>
            </div>
            <div className="col-md-8 mt-2">
              <select
                className="form-control"
                onChange={(e) => setAuth(e.target.value)}
                value={auth}
              >
                <option value="no-auth">No Auth</option>
                <option value="basic-auth">Basic Auth</option>
                <option value="token-auth">Bearer Token Auth</option>
              </select>
            </div>
            {auth === "basic-auth" && (
              <>
                <div className="col-md-6 mt-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Your Username"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                  />
                </div>
                <div className="col-md-6 mt-3">
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter Your Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
              </>
            )}
            {auth === "token-auth" && (
              <div className="col-md-12 mt-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Your Token"
                  value={bearerToken}
                  onChange={(e) => setBearerToken(e.target.value)}
                />
              </div>
            )}
            <div className="col-md-12 mt-3">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Your Rest API Link"
                onChange={(e) => setApiLink(e.target.value)}
              />
            </div>
            <div className="col-md-12 mt-3">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Your Main Variable Name"
                value={mainVariable}
                onChange={(e) => setMainVariable(e.target.value)}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button negative onClick={handleCancelFetchModal}>
            Cancel
          </Button>
          <Button positive onClick={handleShowFetchModal}>
            Fetch
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen={fullScreen}
        open={showConfirmationModal}
        onClose={handleCancelConfirmationModal}
        aria-labelledby="confirmation-dialog-title"
      >
        <DialogTitle id="confirmation-dialog-title">{"Confirm Fetched Data"}</DialogTitle>
        <DialogContent>
          {fetchedData.length > 0 ? (
            <div>
              <h5>Fetched Data:</h5>
              <ul>
                {fetchedData.map((item, index) => (
                  <li key={index}>
                    Name: {getNestedProperty(item, fetchName)}, Description: {getNestedProperty(item, fetchDescription)}
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <p>No data fetched</p>
          )}
        </DialogContent>
        <DialogActions>
          <Button negative onClick={handleCancelConfirmationModal}>
            Cancel
          </Button>
          <Button positive onClick={handleConfirmFetch}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default FetchCampus;